import React, { useContext } from 'react';

import { TableCell, TableHead, TableRow, TableSortLabel } from '@mui/material';
import styled from 'styled-components';

import { type AttendanceTableColumns, type Order } from './types';
import { AttendanceContext, View } from '../../context/AttendanceContext';

const HeadCell = styled(TableCell)`
    font-weight: bold;
    &:focus-within {
        border: 2px solid #ffba00;
    }
` as typeof TableCell;

interface HeadCellData {
    id: AttendanceTableColumns;
    label: string;
}

export interface AttendanceTableHeadProps {
    order: Order;
    orderBy: string;
    onRequestSort: (event: React.MouseEvent<unknown>, property: AttendanceTableColumns) => void;
}

const AttendanceTableHead: React.FC<AttendanceTableHeadProps> = ({ order, orderBy, onRequestSort }) => {
    const { t, view, classSessionId } = useContext(AttendanceContext);

    const headCells: HeadCellData[] = [
        { id: 'attendance', label: t('attendance') },
        { id: 'tardiness', label: t('tardiness') },
        { id: 'timeIn', label: t('time-in') },
        { id: 'timeOut', label: t('time-out') }
    ];

    if (view === View.Session) {
        headCells.unshift({ id: 'sortName', label: t('student') });
    }

    if (view === View.Student) {
        headCells.unshift({ id: 'date', label: t('date') });
    }

    if (classSessionId === 'all') {
        headCells.push({ id: 'totalAbsences', label: t('total-absences') });
    }

    const createSortHandler = (property: AttendanceTableColumns) => (event: React.MouseEvent<unknown>) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell, index) => (
                    <HeadCell
                        key={index}
                        align={index === 0 ? 'left' : 'center'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                        </TableSortLabel>
                    </HeadCell>
                ))}
                <HeadCell align="center">{t('edit')}</HeadCell>
                <HeadCell align="center">{t('report')}</HeadCell>
            </TableRow>
        </TableHead>
    );
};

export default AttendanceTableHead;
